module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card-columns cols-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('line-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('bar-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('doughnut-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('radar-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('pie-example')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('polar-area-example')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Line Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Bar Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Doughnut Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Radar Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Pie Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Polar Area Chart\n        "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "href": "http://www.chartjs.org"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("docs")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e2b79ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coreui/Charts.vue
// module id = 986
// module chunks = 1